// extracted by mini-css-extract-plugin
export default {"root":"MainPage_root__pmIcJ","bg":"MainPage_bg__wXA+D","bgImg":"MainPage_bgImg__Rhty9"};